import { render } from "./WatchLiveEditPane.vue?vue&type=template&id=5bbc2ba4&scoped=true&ts=true"
import script from "./WatchLiveEditPane.vue?vue&type=script&lang=ts"
export * from "./WatchLiveEditPane.vue?vue&type=script&lang=ts"

import "./WatchLiveEditPane.vue?vue&type=style&index=0&id=5bbc2ba4&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbc2ba4"]])

export default __exports__